<div class="order-detail">
  <h4>Key Dates</h4>

  @if (upcoming) {
    <span class="ul-title">Upcoming</span>
    <ul class="upcoming">
      @for (i of upcoming; track $index) {
        <li class="upcoming-ul">
          <mat-icon [inline]="true">{{ iconUpcoming }}</mat-icon>
          <span class="info-title">
            {{ i.title }}
          </span>
          <span class="info-value">{{ i.value || '-' }}</span>
        </li>
      }
    </ul>
  }

  @if (past) {
    <span class="ul-title">Past</span>
    <ul class="past-ul">
      @for (i of past; track $index) {
        <li>
          <mat-icon [inline]="true">{{ iconPast }}</mat-icon>
          <span class="info-title">
            {{ i.title }}
          </span>
          <span class="info-value">{{ i.value | date: 'MM/dd/yyyy' }}</span>
        </li>
      }
    </ul>
  }
</div>
